import { Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClinicForm } from '@models/forms/clinic-form';
import { ServiceTemplateForm } from '@models/forms/service-template-form';

@Component({
  selector: 'app-assign-treatment-form',
  templateUrl: './assign-treatment-form.component.html',
  styleUrls: ['./assign-treatment-form.component.less'],
})
export class AssignTreatmentFormComponent {
  @Input() treatmentForms: ClinicForm[];
  @Input() assignedForms: ServiceTemplateForm[];
  selectedForm: ClinicForm = null;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AssignTreatmentFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  alreadyAssigned(form: ClinicForm) {
    return this.assignedForms?.some((assignedForm) => assignedForm.clinicFormId == form.id);
  }

  onSelectRow(e) {
    if (e.selectedRows.length > 0) {
      this.selectedForm = e.selectedRows[0].dataItem;
    }
  }

  assignTreatmentFormHandler(treatmentForm: ClinicForm) {
    this.dialogRef.close(treatmentForm);
  }
}
